<script setup lang="ts">
import BaseButton from '@/components/ui/BaseButton/BaseButton.vue'
import BaseDialog from '@/components/ui/BaseDialog/BaseDialog.vue'
import { useModal } from '@/composables/useModal'
import { ref, type Component } from 'vue'

const { closeModal } = useModal()

const isOpened = ref(true)

const props = withDefaults(
  defineProps<{
    id: number
    resolve: (data: boolean | undefined) => void
    reject: (data: any) => void
    titleText: string
    contentText?: string
    contentComponent?: Component
    preTitleComponent?: Component
    confirmButtonText?: string
    cancelButtonText?: string
    confirmButtonVariant?: 'primary' | 'secondary' | 'error' | 'orange'
    cancelButtonVariant?: 'primary' | 'secondary' | 'error' | 'orange' | 'gray'
    reversedButtons?: boolean
    unrestrictedWidth?: boolean
    hideActionButton?: boolean
  }>(),
  {
    confirmButtonText: 'Confirm',
    cancelButtonText: 'Cancel',
    confirmButtonVariant: 'primary',
    cancelButtonVariant: 'gray',
  },
)

const handleCloseModal = (value: boolean | undefined) => {
  if (!value) {
    props.resolve(undefined)
    closeModal(props.id)
  }
}

const handleCancel = () => {
  props.resolve(false)
  closeModal(props.id)
}

const handleConfirm = () => {
  props.resolve(true)
  closeModal(props.id)
}
</script>

<template>
  <BaseDialog
    :model-value="isOpened"
    @update:model-value="handleCloseModal"
    description="test"
    hide-description
    :restricted-width="!unrestrictedWidth"
  >
    <template v-if="props.preTitleComponent" #pretitle>
      <component :is="props.preTitleComponent" />
    </template>
    <template #title>{{ props.titleText }}</template>
    <template #content>
      <div class="whitespace-pre-line">
        {{ props.contentText }}
      </div>
      <component v-if="props.contentComponent" :is="props.contentComponent" />
    </template>
    <template v-if="!hideActionButton" #actions>
      <BaseButton
        :text="props.cancelButtonText"
        :variant="props.cancelButtonVariant"
        @click="handleCancel"
        :class="{ 'order-1': props.reversedButtons }"
      />
      <BaseButton
        v-if="props.confirmButtonText"
        :text="props.confirmButtonText"
        :variant="props.confirmButtonVariant"
        @click="handleConfirm"
      />
    </template>
  </BaseDialog>
</template>
